import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class FulfillmentStepsTableNewComponent implements IController {

  infiniteScroll: any;
  selectedSteps: any[];
  excludeMode: boolean;
  onSelectedStepsChanged: Function;

  private selectedKeys = undefined;


  constructor() {
  }

  $onInit() {
    this.selectedKeys = {};
    _.forEach(this.selectedSteps, (step) => {
      this.selectedKeys[step.id] = true;
    });
  }

  $onChanges(changes) {
    if (changes.selectedSteps && !changes.selectedSteps.isFirstChange()) {
      this.$onInit();
    }
  };

  setEvents() {
    const div1 = document.getElementById('header');
    const div2 = document.querySelectorAll('.md-virtual-repeat-scroller')[0];

    div2.addEventListener('scroll', e => {
      div1.scrollTop = div2.scrollTop;
      div1.scrollLeft = div2.scrollLeft;
    }, {passive: true})
  }

  // onToggleSelectAll() {
  //   this.onSelectedStepsChanged({
  //     selectedSteps: [],
  //     excludeMode: !this.excludeMode
  //   });
  // }

  onToggleStepSelect(step) {
    this.selectedKeys[step.id] = !this.selectedKeys[step.id];

    const stepIndex = _.findIndex(this.selectedSteps, selectedStep => {
      return selectedStep.id === step.id;
    })

    const selectedStepsCopy = angular.copy(this.selectedSteps);

    if (stepIndex > -1) {
      selectedStepsCopy.splice(stepIndex, 1);
    } else {
      selectedStepsCopy.push(step);
    }

    this.onSelectedStepsChanged({
      selectedSteps: selectedStepsCopy,
      excludeMode: this.excludeMode
    })
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentStepsTableNew', {
    bindings: {
      infiniteScroll: '<',
      selectedSteps: '<',
      excludeMode: '<?',
      onSelectedStepsChanged: '&'
    },
    template: require('./fulfillment-steps-table-new.html').default,
    controller: FulfillmentStepsTableNewComponent
  });
